module.exports = __webpack_public_path__ + "static/media/installation-bee-hives-new-location.8c0212f5.jpg";